var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightMiddle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "56px",
    viewBox: "0 0 78 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pixagri",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Aide-4",
    transform: "translate(-1045.000000, -439.000000)",
    stroke: "#9EBE4A",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(1084.120495, 467.370359) rotate(-17.000000) translate(-1084.120495, -467.370359) translate(1050.858091, 451.272403)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line-21",
    strokeLinejoin: "round",
    transform: "translate(4.885807, 9.364543) rotate(-102.000000) translate(-4.885807, -9.364543) ",
    points: "0.781106798 5.24206442 8.7811068 5.24206442 8.99050807 13.4870209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77313736,18.5376056 C29.6981996,26.6118111 54.0567496,22.0306018 66.0976729,9.62171764",
    id: "Line-8",
    transform: "translate(33.935405, 16.097956) rotate(18.000000) translate(-33.935405, -16.097956) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightMiddle);
export default __webpack_public_path__ + "static/media/arrow_right_middle.25d8b962.svg";
export { ForwardRef as ReactComponent };